const formatDate = (value) => {
  let date = new Date(value);
  let formattedDate = date.toLocaleDateString('it-IT').replaceAll('/','-');

  return formattedDate;
  
};

const formatDateTime = (value) => {
  let date = new Date(value);
  let formattedDate = date.toLocaleDateString('it-IT') + " " + date.toLocaleTimeString('it-IT');

  return formattedDate;
  
};

export {formatDate, formatDateTime};